import CitiesService from "../services/CitiesService";
import { debounce } from "../utils/utils";

export default class CityLookup extends HTMLInputElement {

    get targetElement() {
        return document.getElementById(this.dataset.target);
    }

    connectedCallback() {

        this.addEventListener("keyup", debounce(this.handleKeyUp, 500, this));
        
    }

    handleKeyUp() {
        this.targetElement.value = null;

        if (this.checkValidity()) {

            const service = new CitiesService();

            service.getCityByZipCode(this.value).then(this.updateCity);
        }        
    }

    updateCity = data => {
        this.targetElement.value = data;
    }

}

customElements.define('city-lookup', CityLookup, { extends: 'input' });